import AmazonRDSReaderNode from './types/amazon-rds-reader';
import AmazonRDSWriterNode from './types/amazon-rds-writer';
import AmazonRedshiftReaderNode from './types/amazon-redshift-reader';
import AmazonRedshiftWriterNode from './types/amazon-redshift-writer';
import AmazonSESConnectorNode from './types/amazon-ses-connector';
import AWSElasticSearchReader5xNode from './types/aws-elastic-search-reader-5x';
import S3ReaderNode from './types/s3-reader';
import S3WriterNode from './types/s3-writer';

export const amazonNodes = {
  amazonRDSReader: AmazonRDSReaderNode,
  amazonRDSWriter: AmazonRDSWriterNode,
  s3Reader: S3ReaderNode,
  s3Writer: S3WriterNode,
  amazonSESConnector: AmazonSESConnectorNode,
  awsElasticsearchReader5x: AWSElasticSearchReader5xNode,
  amazonRedshiftReader: AmazonRedshiftReaderNode,
  amazonRedshiftWriter: AmazonRedshiftWriterNode,
};
